// import 'choices.js/public/assets/scripts/choices.min';
import Choices from 'choices.js';
import 'core-js/es/array/find';
import 'core-js/es/array/find-index';
import 'core-js/es/array/from';
import 'core-js/es/array/includes';
import mobile from 'is-mobile';
import debounce from 'lodash/debounce';

class CustomSelect {
    constructor($el) {
        this.$select = $el;

        this.options = {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            position: 'bottom'
        };

        this.wrap();
        this.init();
        window.addEventListener('resize', debounce(this.init.bind(this), 100));
        this.$select.addEventListener('set', this.setOptions.bind(this));
        this.$select.addEventListener('select', this.setValue.bind(this));
    }

    wrap() {
        this.$wrap = document.createElement('div');

        this.$wrap.className = this.$select.className + ' custom-select';
        this.$select.insertAdjacentElement('afterend', this.$wrap);
        this.$wrap.insertAdjacentElement('afterbegin', this.$select);
    }

    init() {
        if (mobile()) {
            this.$wrap.classList.add('custom-select-native');

            if (this.select) {
                let value = this.select.getValue(true);
                this.select.destroy();
                delete this.select;
                this.$select.value = value;
            }
        } else {
            this.$wrap.classList.remove('custom-select-native');

            if (!this.select) {
                this.select = new Choices(this.$select, this.options);

                this.select.dropdown.element.classList.add(this.select.dropdown.classNames.listDropdown); // fix na IE - dropdown z niewiadomych powodow nie ma tej klasy
            }
        }

        this.fixIOS();
    }

    fixIOS() {
        // iOS hack: Add an optgroup to every select in order to avoid truncating the content
        if (navigator.userAgent.match(/(iPad|iPhone|iPod touch)/i)) {
            this.$select.appendChild(document.createElement('optgroup'));
        }
    }

    setOptions(e) {
        let options= e.detail;

        if (this.select) {
            this.select.setChoices(options, 'value', 'label', true);
        } else {
            this.$select.innerHTML = '';
            this.$select.insertAdjacentHTML('beforeend', options.map(o => `<option value="${o.value}" ${o.disabled ? 'disabled="disabled"' : ''}>${o.label}</option>`).join())
        }
    }

    setValue(e) {
        let value = e.detail;

        if (this.select) {
            this.select.setChoiceByValue(value);
        } else {
            this.$select.value = value;
        }
    }
}

export default CustomSelect;
